import { register } from '../modules/sections.js'
import Section from '../modules/section.js'
import { on } from '../modules/events.js'

class TopSection extends Section {
  initState() {
    return {
      isTop: true,
      scrollDirection: null,
      navDisplay: false,
      langToggleActive: false
    }
  }

  init() {
    this.computed(() => this.isTopChanged(this.state.isTop))
    this.computed(() => this.scrollDirectionChanged(this.state.scrollDirection))
    this.computed(() => this.navDisplayChanged(this.state.navDisplay))
    this.computed(() => this.langToggleActiveChanged(this.state.langToggleActive))
    this.scrollHandle()

    if (this.refs.menu) {
      on(this.refs.menu, 'pointerup', () => {
        this.state.navDisplay = !this.state.navDisplay
      })
    }

    if (this.refs.langToggle) {
      on(this.refs.langToggle, 'pointerup', () => {
        this.state.langToggleActive = !this.state.langToggleActive
      })
    }
  }

  scrollHandle() {
    let timeout
    let y = window.scrollY

    const scrollTest = function() {
      const currentY = window.scrollY
      
      if (currentY <= 0) {
        if (!this.state.isTop) {
          this.state.isTop = true
        }
      }
      else {
        if (this.state.isTop) {
          this.state.isTop = false
        }
      }
      
      if (currentY > y) {
        this.state.scrollDirection = 'down'
      }
      else if (currentY < y) {
        this.state.scrollDirection = 'up'
      }
      else {
        this.state.scrollDirection = null
      }

      y = currentY
    }.bind(this)

    // immediate call
    scrollTest()

    const scrollListener = function() {
      if (timeout) {
        return
      }
      else {
        // immediate call
        if (timeout === undefined) {
          scrollTest()
        }
        timeout = setTimeout(() => {
          timeout = null
          scrollTest()
        }, 50)
      }
    }.bind(this)

    on(window, 'scroll', scrollListener)
  }

  isTopChanged(value) {
    this.el.dataset.top = value ? 1 : 0
  }

  scrollDirectionChanged(value) {
    this.el.dataset.direction = value ? value : ''
  }

  navDisplayChanged(value) {
    this.el.dataset.navDisplay = value ? 1 : 0
  }

  langToggleActiveChanged(value) {
    this.refs.langToggle.dataset.active = value ? 1 : 0
  }
}

register('top', TopSection)
